import { useModalContext } from '@sketch/components'
import { useRegisterCommandBarCommands } from '@sketch/modules-common'

import { createSelectedItemsCommands } from './createSelectedItemsCommands'
import { StorageItemIdentity } from '../types'

interface SelectedItemsCommandBarActions {
  isArchiveButtonAvailable: boolean
  isMoveButtonAvailable: boolean
  isRestoreButtonAvailable: boolean
  isTrashButtonAvailable: boolean
  isUnarchiveButtonAvailable: boolean
  parentProjectIdentifier: string | null
}

interface SelectedItemsCommandBarRegistrationProps {
  actions: SelectedItemsCommandBarActions
  onClearSelection: () => void
  selectedItems: StorageItemIdentity[]
  workspaceIdentifier: string
}

export const SelectedItemsCommandBarRegistration = ({
  actions,
  onClearSelection,
  selectedItems,
  workspaceIdentifier,
}: SelectedItemsCommandBarRegistrationProps) => {
  const { showModal } = useModalContext()
  const {
    isArchiveButtonAvailable,
    isMoveButtonAvailable,
    isRestoreButtonAvailable,
    isTrashButtonAvailable,
    isUnarchiveButtonAvailable,
    parentProjectIdentifier,
  } = actions
  const canRestore = isRestoreButtonAvailable || isUnarchiveButtonAvailable
  const restoreAction = isRestoreButtonAvailable ? 'restore' : 'unarchive'

  useRegisterCommandBarCommands(
    'selected-items',
    () =>
      createSelectedItemsCommands({
        canArchive: isArchiveButtonAvailable,
        canDelete: isTrashButtonAvailable,
        canMove: isMoveButtonAvailable,
        canRestore,
        onClearSelection,
        parentProjectIdentifier,
        restoreAction,
        selectedItems,
        showModal,
        workspaceIdentifier,
      }),
    [
      workspaceIdentifier,
      selectedItems.map(item => `${item.__typename}:${item.identifier}`).join(),
      isArchiveButtonAvailable,
      isTrashButtonAvailable,
      isMoveButtonAvailable,
      canRestore,
      onClearSelection,
      parentProjectIdentifier,
      restoreAction,
    ]
  )

  return null
}
